// extracted by css-extract-rspack-plugin
export default {"products-sold":"KRrg6o","productsSold":"KRrg6o","sales-volume":"wpkiJP","salesVolume":"wpkiJP"};